export const checkIsNaN = (_value: number) => (isNaN(_value) ? 0 : _value);

export const checkIsNaNToString = (_value: number, fixed?: boolean) =>
  isNaN(_value) ? '無資料' : fixed ? _value?.toFixed(4) : _value;
